import { UserToken } from '../types/auth';

// set document title for ios native view @staffbase
export function setWindowTitleFromJWT() {
  try {
    const jwtPayloadPart = window.location.search.match(/jwt=\w+\.(\w+)./);
    if (jwtPayloadPart) {
      const b64Payload = decode(jwtPayloadPart[1]);
      const payload = JSON.parse(window.atob(b64Payload)) as UserToken;
      document.title = payload.instance_name;
    }
  } catch (err) {
    console.warn('problem reading title from jwt', err);
  }
}

function decode(input: string): string {
  // Replace non-url compatible chars with base64 standard chars
  input = input.replace(/-/g, '+').replace(/_/g, '/');

  // Pad out with standard base64 required padding characters
  const pad = input.length % 4;
  if (pad) {
    if (pad === 1) {
      throw new Error(
        'InvalidLengthError: Input base64url string is the wrong length to determine padding',
      );
    }
    input += new Array(5 - pad).join('=');
  }
  return input;
}
